import { NgModule } from '@angular/core';
import { ConfirmationDialogModule } from './confirmation-dialog/confirmation-dialog.module';
import { NgxSvgModule } from './ngx-svg/ngx-svg.module';

const COMPONENTS_EXPORT = [];
const COMPONENTS_ENTRY = [];
const COMPONENTS = [...COMPONENTS_EXPORT, ...COMPONENTS_ENTRY];

const MODULES_EXPORT = [
  ConfirmationDialogModule,
  NgxSvgModule
];
const MODULES = [...MODULES_EXPORT];

@NgModule({
  declarations: [...COMPONENTS],
  entryComponents: [...COMPONENTS_ENTRY],
  imports: [...MODULES],
  exports: [...MODULES_EXPORT, ...COMPONENTS_EXPORT]
})
export class SharedComponentsModule {
}
